module.exports = __webpack_public_path__ + "static/media/transporter.e0afefdb.svg";